export const ASSETS_BASE_URL = 'https://bossdb-assets.s3.amazonaws.com/';
export const PROJECT_DATA_URL = 'https://bossdb-metadata-snapshot.s3.amazonaws.com/mongo-data.json';
export const POSTERS_BASE_URL = 'https://bossdb-datalake.s3.amazonaws.com/public/posters/';